// extracted by mini-css-extract-plugin
module.exports =  {"projects-list":"a10a3f92e9--projects-list--R24yh"};